import React, { Component, Fragment, Suspense } from 'react'
import { Helmet } from 'react-helmet'
import Tabs from 'antd/lib/tabs'
import message from 'antd/lib/message'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { mapDispatchToProps } from '../../helpers/redux.helper'
import Loader from '../Loader'
import Address from './Address'
import './index.sass'
import InvoiceDetails from '../InvoiceDetails'
import Breadcrumbs from '../Breadcrumbs'
import ScrollUpButton from '../ScrollUpButton'
const { TabPane } = Tabs

const FormComponent = React.lazy(() => import('../FormComponent'))

class Contacts extends Component {
  componentDidMount = () => {
    const {
      contacts,
      actions: { getContacts },
    } = this.props

    if (!contacts.contacts) {
      getContacts()
    }
  }

  componentDidUpdate = () => {
    if (this.props.statusMessage) {
      this.showStatusMessage()
    }
  }

  showStatusMessage = () => {
    const {
      statusMessage,
      actions: { setStatusMessage },
    } = this.props
    message.info(statusMessage)
    setStatusMessage('')
  }

	copyToClipBoard = () => {
		navigator.clipboard.writeText(this.props.contacts.contacts.email)
		message.info('Email copied!', 1)
	}

  render = () => {
    const {
      contacts: { contacts },
      loading,
      loadingStatus,
      actions: {
        createFeedBack,
        setChoosenVoice,
        setContactLoadingStatus,
        clearContactLoadingStatus,
        setStatusMessage,
      },
      t,
      lng,
    } = this.props
    return (
      <Fragment>
        <Helmet>
          <html lang={lng} />
          <title>{t('meta.contacts.title')}</title>
          <link rel="alternate" hrefLang="en"
              href="https://unimedia.io/contacts" />
          <link rel="alternate" hrefLang="de"
              href="https://unimedia.io/de/contacts" />
          <link rel="alternate" hrefLang="ru"
              href="https://unimedia.io/ru/contacts" />
          <link rel="alternate" hrefLang="x-default"
              href="https://unimedia.io/contacts" />
          <meta name="description" content={t('meta.contacts.descr')} />
          {lng === 'en' && <meta name="keywords" content={t('meta.contacts.keywords')} />}
          {lng === 'en' ? <link rel="canonical" href={'https://unimedia.io/contacts'} /> : <link rel="canonical" href={`https://unimedia.io/${lng}/contacts`} />}
          <meta property="og:title" content={t('meta.contacts.title')} />
          <meta property="og:description" content={t('meta.contacts.descr')} />
          <meta property="og:image" content="https://unimedia.io/assets/logo.svg" />
          <meta property="og:url" content={lng === 'en' ? 'https://unimedia.io/contacts': `https://unimedia.io/${lng}/contacts`} />
          <script type="application/ld+json">
          {`[{
              "@context" : "https://schema.org/",
              "@type": "Product",
              "name": "${t('productDescription')}",
              "image": "https://unimedia.io/assets/logo.svg",
              "description": "${t('meta.contacts.descr')}",
              "brand": {
                "@type": "Brand",
                "name": "Universal Media"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "bestRating": "5",
                "reviewCount": "5"
              }
            },
            {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Universal Media",
                "alternateName": "Unimedia",
                "url": "https://unimedia.io",
                "logo": "https://unimedia.io/assets/logo.svg"
            },
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "${t('navigations.home')}",
                "item": "https://unimedia.io"
              },{
                "@type": "ListItem",
                "position": 2,
                "name": "${t('navigations.contacts')}"
              }]
            }]`}
          </script>
        </Helmet>
        <ScrollUpButton id={'contacts'} />
        <Suspense fallback={<Loader />}>
          <div className="contacts-page container overflow-y" id={'contacts'}>
            <div className="container-wrapper">
            <Breadcrumbs pathname={window.location.pathname} color='white'/>
							<h1 className="main-title">{t('contacts.title')}</h1>
              {loading ? (
                <Loader />
              ) : (
                contacts && (
                  <Fragment>
                    <div className="contacts-info">
                      <Tabs defaultActiveKey="1">
                        <TabPane tab={t('general.ourOffices')} key="1">
                          <div className="contacts-adress">
                            {contacts.address.map((el, ind) => (
                              <Address tel={el.tel} key={ind} ind={ind} lang={lng} />
                            ))}
                            
                          </div>
                          <div className='contacts-container'>
                            <div className="messengers-block">
                              <div className='body-light'>{t('contacts.reachUs')}</div>
                              <a href='https://t.me/uni_media_bot' rel="noopener noreferrer nofollow" target={'_blank'}>
                                <img src="/assets/social/telegram.svg" alt="telegram" />
                              </a>
                              <a href='https://wa.me/19892083369' rel="noopener noreferrer nofollow" target={'_blank'}>
                                <img src="/assets/social/whatsapp.svg" alt="whatsapp" />
                              </a>
                            </div>
                            <div className="contact-email"><a href = "mailto: info@unimedia.io">{contacts.email}</a><span onClick={this.copyToClipBoard} className="contact-copy-icon"/></div>
                            <div className="payment-logos">
                              <a href='https://www.instagram.com/unimedia.io/' rel="noopener noreferrer nofollow" target={'_blank'}>
                                <img src="/assets/social/ic-instagram.svg" alt="instagram" />
                              </a>
                              <a href='https://www.facebook.com/unimedia.io/' rel="noopener noreferrer nofollow" target={'_blank'}>
                                <img src="/assets/social/ic-facebook.svg" alt="facebook" />
                              </a>
                              <a href='https://www.linkedin.com/company/68529641' rel="noopener noreferrer nofollow" target={'_blank'}>
                                <img src="/assets/social/ic-limkedin.svg" alt="linkedin" />
                              </a>
                            </div>
                          </div>
                        </TabPane>
                        <TabPane tab={t('general.invoiceDetails')} key="2">
                          <InvoiceDetails />
                        </TabPane>
                      </Tabs>

                      {/* <div
                        className="contacts-map"
                        style={{ backgroundImage: `url(${contacts.map})` }}
                      ></div> */}
                      
                    </div>
                    
                    <div className="contacts-form">
                      <h6>{t('contacts.subtitle')}</h6>
                      <div className='additionalNote'>{t('contacts.additionalNote')}<a href = "mailto: j.molla@unimedia.io">j.molla@unimedia.io</a></div>
                      
                      <FormComponent
                        createFeedBack={createFeedBack}
                        loadingStatus={loadingStatus}
                        setChoosenVoice={setChoosenVoice}
                        setContactLoadingStatus={setContactLoadingStatus}
                        clearContactLoadingStatus={clearContactLoadingStatus}
                        setStatusMessage={setStatusMessage}
                      />
                    </div>
                  </Fragment>
                )
              )}
            </div>
          </div>
        </Suspense>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  contacts: state.contacts,
  loading: state.app.loading,
  loadingStatus: state.contacts.loadingStatus,
  statusMessage: state.contacts.statusMessage,
})

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Contacts)
)
